import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import Stafflist from './staff';

function Staffcontroller() {
    return[
     
        
        <Topnavbar />,
      
        <Sidennav />,
        <Stafflist />,
    ];
    
}

export default Staffcontroller;
